import bind from 'bind-decorator';
import { Icon } from 'elements';
import { ROUTES } from 'global/constants';
import * as React from 'react';

import { UserAvatar } from 'user/components/UserAvatar';
import { WrappedMessage } from 'utils';
import messages from '../displayMessages';
import { DropdownList } from '../Dropdown';

interface LoggedInMenuProps {
    onLogOut: () => void;
    username: string;
    className?: string;
}

export class LoggedInMenu extends React.Component<LoggedInMenuProps> {

    public render() {
        const avatar = <UserAvatar
            username={this.props.username}
        />;
        return (
                <DropdownList
                    id='menu-logged-in'
                    label={avatar}
                    className={`logged-in-menu-button ${this.props.className ? this.props.className : ''}`}
                    links={[
                        {
                            key: 'myprofile',
                            to: ROUTES.Users.PROFILE_EDIT_SLUG(this.props.username),
                            content: <>
                                <Icon zoom='16px' name='person' className='logged-in-menu-icon' />
                                <WrappedMessage message={messages.uiMyProfile}/>
                            </>,
                        },
                        {
                            key: 'settings',
                            to: ROUTES.Personal.PROFILE_SETTINGS,
                            content: <>
                                <Icon zoom='16px' name='settings2' className='logged-in-menu-icon' />
                                <WrappedMessage message={messages.uiSettings}/>
                            </>,
                        },
                        {
                            key: 'logout',
                            to: '/logout',
                            onClick: this.onLogOut,
                            content: <>
                                <Icon zoom='16px' name='key' className='logged-in-menu-icon' />
                                <WrappedMessage message={messages.uiLogOut}/>
                            </>,
                        },
                    ]}
            />

        );
    }

    @bind private onLogOut(event: React.MouseEvent): void {
        event.preventDefault();
        this.props.onLogOut();
    }
}
